import {
  Table as TableType,
  FibreList,
  CatalogueTable,
} from "../Constants/GlobalConstant";
import {
  CreateVIPSVarOrderDetailItemObject2,
  CreateVIPSVarOrderDetailItemObject,
  checkQuantityFieldName2,
} from "../CommonFuntion/OrderingHelper";

const getLabelSessionEntries = (labelSession) => {
  const raw = labelSession?.LabelSession;
  if (Array.isArray(raw)) {
    return raw
      .map((entry) => {
        if (entry && typeof entry === "object") return entry;
        if (typeof entry === "string" && entry.trim() !== "") {
          return { labelRef: entry };
        }
        return null;
      })
      .filter(Boolean);
  }
  if (raw && typeof raw === "object") return [raw];
  if (typeof raw === "string" && raw.trim() !== "") return [{ labelRef: raw }];
  return [];
};

const findLabelSchemaField = (schemaArr, labPrefix) => {
  if (!Array.isArray(schemaArr)) return undefined;
  return (
    schemaArr.find((x) => x?.prefix === labPrefix) ??
    schemaArr
      .flatMap((x) =>
        Array.isArray(x?.schemaPageSubItems) ? x.schemaPageSubItems : []
      )
      .find(
        (x) =>
          x?.prefix === labPrefix ||
          x?.tagName === "LABELREF" ||
          x?.tagName === "LABEL"
      )
  );
};

const findLabelSchemaFieldAcrossPages = (schemaObject, labPrefix) => {
  if (!Array.isArray(schemaObject)) return undefined;
  for (const pageSchema of schemaObject) {
    const normalizedSchema = Array.isArray(pageSchema)
      ? pageSchema
      : [pageSchema];
    const labelSchemaField = findLabelSchemaField(normalizedSchema, labPrefix);
    if (labelSchemaField) return labelSchemaField;
  }
  return undefined;
};

export const CreateVIPSVarOrderDetailItem = (
  user,
  line,
  arrIndex,
  schemaObject,
  VIPSVarOrderDetailItems,
  tableIndex,
  pageIdOfSchemObject
) => {
  Object.entries(user)?.forEach(([key, value]) => {
    const schema = schemaObject?.find((x) => x.fieldName === key);

    var index = 0;
    if (schema) {
      if (schema.dataType === TableType || schema.prefix === "CTB") {
        let data, tableIndex;
        data = value[ schema.prefix === "CTB"? arrIndex : schema.numberOfLinesToDisplay > 1 ? arrIndex : 0];
        tableIndex = line;
        if (data)
          CreateVIPSVarOrderDetailItem(
            data,
            line,
            arrIndex,
            schema?.schemaPageSubItems,
            VIPSVarOrderDetailItems,
            tableIndex,
            pageIdOfSchemObject
          );
      } else if (schema.dataType === FibreList) {
        const fibreData = user[schema.fieldName];
        let fiberIndex = 1;
        fibreData
          ?.filter((x) => x.isSave)
          ?.forEach((garment) => {
            garment?.garment?.forEach((garment2) => {
              CreateVIPSVarOrderDetailItemObject(
                schema,
                garment2.garment,
                `_${fiberIndex}`,
                VIPSVarOrderDetailItems,
                schema.fieldName,
                fiberIndex
              );
              fiberIndex++;
            });
            garment?.fibres?.forEach((fibre) => {
              CreateVIPSVarOrderDetailItemObject(
                schema,
                fibre.percentage > 0
                  ? `${fibre.percentage}% ${fibre.fibre}`
                  : `${fibre.fibre}`,
                `_${fiberIndex}`,
                VIPSVarOrderDetailItems,
                schema.fieldName,
                fiberIndex
              );
              fiberIndex++;
            });
          });
      } else if (schema.prefix === "CCL") {
        const cclData = user[schema.fieldName][0];
        let index = 1;
        const careControls = schema?.careControls;
        for (const key in cclData) {
          if (cclData[key]?.length > 0) {
            const careControl = careControls[index - 1];
            CreateVIPSVarOrderDetailItemObject(
              schema,
              cclData[key],
              `_${index}`,
              VIPSVarOrderDetailItems,
              schema.fieldName + "-" + careControl.tagName,
              index
            );
          }
          index++;
        }
      } else if (schema.prefix === "LIB") {
        const data = user[schema.fieldName];
        if (data) {
          data.forEach((x, index) => {
            CreateVIPSVarOrderDetailItemObject(
              schema,
              x[schema.fieldName],
              `_${index + 1}`,
              VIPSVarOrderDetailItems,
              schema.fieldName,
              index + 1
            );
          });
        }
      } else {
        if (schema.prefix !== "STC") {
          CreateVIPSVarOrderDetailItemObject(
            schema,
            value,
            `_1`,
            VIPSVarOrderDetailItems,
            schema.fieldName
          );
        } else {
          if (schema.prefix === "STC" && schema.display) {
            CreateVIPSVarOrderDetailItemObject(
              schema,
              value,
              `_1`,
              VIPSVarOrderDetailItems,
              schema.fieldName
            );
          } else if (
            schema.prefix === "STC" &&
            !schema.display &&
            schema.value
          ) {
            CreateVIPSVarOrderDetailItemObject(
              schema,
              schema.value,
              `_1`,
              VIPSVarOrderDetailItems,
              schema.fieldName
            );
          }
        }
      }
    } else {
      if (key.startsWith("INQ"))
        CreateVIPSVarOrderDetailItemObject2(
          key,
          value,
          `_1`,
          VIPSVarOrderDetailItems,
          "Entered Quantity",
          tableIndex,
          pageIdOfSchemObject
        );
    }
    index++;
  });
};

export const CreateVIPSOrderDetailsItem = (
  newtempArr,
  schemaObject,
  user,
  LabPrefix,
  LabelSession
) => {
  let VIPSOrderDetailsItems = [];
  let iterateCount = 1;
  newtempArr.forEach((value, index) => {
      // Implied items: create a simple order line with just label and quantity
    if (value.isImpliedItem) {
  const VIPSVarOrderDetailItem = [
        {
        }
      ];
      const VIPSOrderDetailsItem = {
    
        line_no: iterateCount.toString().padStart(4, "0"),
        block_no: value["LineNo"],
        product_id: value["ProductDesc"],
        quantity: (value["Quantity"] || 0).toString(),
        erp_product_id: "",
        itemStatus: "Y",
        action: "",
        VIPSVarOrderDetailItem
      };
      VIPSOrderDetailsItems.push(VIPSOrderDetailsItem);
      iterateCount++;
      return;
    }

    // Determine which schema/user to use
    const schemaIdx = schemaObject[index] !== undefined ? index : 0;
    const userIdx = schemaObject[index] !== undefined ? index : 0;
    const schemaArr = schemaObject[schemaIdx];
    const userObj = user[userIdx];

    const [quantityFieldName, tableName] = checkQuantityFieldName2(schemaArr);
    const pageIdOfSchemObject = schemaArr[0]?.pageId;

    // Resolve quantity field from schema subitems (QTY or catalogueSchemaType == 16)
    const qtyFieldFromSchema =
      schemaArr
        ?.flatMap((s) =>
          Array.isArray(s?.schemaPageSubItems) ? s.schemaPageSubItems : []
        )
        ?.find((x) => x?.prefix === "QTY" || x?.catalogueSchemaType === 16)
        ?.fieldName || quantityFieldName;

    // Prefer metadata from tempArr for label-only lines
    const effectiveTableName = value.TableName || tableName;
    const providedQFN = Array.isArray(value.QuantityFieldName)
      ? value.QuantityFieldName[0]
      : value.QuantityFieldName;
    const qtyField = qtyFieldFromSchema || providedQFN || quantityFieldName;

    // Build filtered rows: by PO for CSV path, else by label reference when available
    let filteredRows = [];
    if (effectiveTableName && Array.isArray(userObj[effectiveTableName])) {
      filteredRows = userObj[effectiveTableName];
      if (value.LabelFieldName && value.ProductDesc && !value.PO) {
        filteredRows = filteredRows.filter(
          (r) => r[value.LabelFieldName] === value.ProductDesc
        );
      }
    }
    let loopCount = 1;
    if (effectiveTableName && qtyField) {
      loopCount =
        filteredRows?.filter(
          (x) => (x[qtyField] ?? "").toString().length > 0
        )?.length || 0;
    }

    const hasLabel = Boolean(findLabelSchemaField(schemaArr, LabPrefix));
    for (let i = 0; i < loopCount; i++) {
      const lineNo = effectiveTableName?.length > 0 ? i + 1 : index + 1;
      let VIPSVarOrderDetailItem = [];
      // Compute the row quantity to decide whether to skip
      let rowQty = value["Quantity"];
      if (effectiveTableName && qtyField) {
        const row = filteredRows?.[i];
        rowQty = row ? row[qtyField] : rowQty;
      }
      const qtyNum = Number(rowQty);
      if (!Number.isFinite(qtyNum) || qtyNum <= 0) {
        continue; // skip zero or invalid qty rows
      }
      // Build a user object that preserves other fields but replaces the active table with filtered rows
      const filterrow =
        effectiveTableName && Array.isArray(filteredRows)
          ? { ...userObj, [effectiveTableName]: filteredRows }
          : userObj;
      CreateVIPSVarOrderDetailItem(
        filterrow,
        lineNo,
        i,
        schemaArr,
        VIPSVarOrderDetailItem,
        lineNo,
        pageIdOfSchemObject
      );

      // Add label if needed
      if (!hasLabel) {
        const labelEntries = getLabelSessionEntries(LabelSession);
        const labelEntry = labelEntries[index] ?? labelEntries[0];
        const labelSchemaField = findLabelSchemaField(schemaArr, LabPrefix);
        const globalLabelSchemaField = findLabelSchemaFieldAcrossPages(
          schemaObject,
          LabPrefix
        );

        const schema = {
          tagName:
            labelEntry?.tagName ??
            labelSchemaField?.tagName ??
            globalLabelSchemaField?.tagName ??
            (value.LabelFieldName || `LABEL${index + 1}`),
          fieldName:
            labelEntry?.fieldName ??
            labelSchemaField?.fieldName ??
            globalLabelSchemaField?.fieldName ??
            (value.LabelFieldName || `LABEL${index + 1}`),
          prefix:
            labelEntry?.prefix ??
            labelSchemaField?.prefix ??
            globalLabelSchemaField?.prefix ??
            "LAB",
          pageId: pageIdOfSchemObject,
        };

        CreateVIPSVarOrderDetailItemObject(
          schema,
          value["ProductDesc"],
          `_1`,
          VIPSVarOrderDetailItem,
          schema.fieldName
        );
      }

      let quantity = qtyNum; // already computed

      const VIPSOrderDetailsItem = {
        line_no: iterateCount.toString().padStart(4, "0"),
        //original_sku_id: iterateCount.toString().padStart(4, "0"),
        block_no: value["LineNo"],
        product_id: value["ProductDesc"],
        quantity: quantity?.toString(),
        erp_product_id: "",
        itemStatus: "Y",
        action: "",
        VIPSVarOrderDetailItem,
      };
      VIPSOrderDetailsItems.push(VIPSOrderDetailsItem);
      iterateCount++;
    }
  });

  return VIPSOrderDetailsItems;
};

export const CreateVIPSVarOrderHeaderItem = (schemaObject, user) => {
  let VIPSVarOrderHeaderItems = [];
  for (let ind = 0; ind < schemaObject.length; ind++) {
    if (!schemaObject[ind] || !user[ind]) continue;
    schemaObject[ind]
      ?.filter(
        (schema) =>
          (schema.dataType === TableType && schema.orientation == 0) ||
          schema.dataType === CatalogueTable
      )
      ?.forEach((schema) => {
        if (schema.fieldName) {
          const numberOfLines = String(user[ind]?.[schema.fieldName]?.length);
          CreateVIPSVarOrderDetailItemObject(
            schema,
            numberOfLines,
            "_rows",
            VIPSVarOrderHeaderItems,
            "",
            "rows"
          );
        }
      });
  }
  const distinctArray = VIPSVarOrderHeaderItems.filter(
    (obj, index, self) =>
      index === self.findIndex((o) => o.variable_id === obj.variable_id)
  );
  return distinctArray;
};

export const CreateVIPSVarOrderHeaderItemForCSVUpload = (
  value,
  schemaObject,
  user
) => {
  let VIPSVarOrderHeaderItems = [];
  for (let ind = 0; ind < schemaObject.length; ind++) {
    schemaObject[ind]
      ?.filter(
        (schema) =>
          (schema.dataType === TableType &&
            schema.orientation == 0 &&
            schema.fieldName === value.TableName) ||
          schema.dataType === CatalogueTable
      )
      ?.forEach((schema) => {
        const numberOfLines = String(user[ind]?.[schema.fieldName]?.length);
        CreateVIPSVarOrderDetailItemObject(
          schema,
          numberOfLines,
          "_rows",
          VIPSVarOrderHeaderItems,
          "",
          "rows"
        );
      });
  }

  const distinctArray = VIPSVarOrderHeaderItems.filter(
    (obj, index, self) =>
      index === self.findIndex((o) => o.variable_id === obj.variable_id)
  );
  return distinctArray;
};

export const CreateVIPSOrderDetailsItemForCSVUpload = (
  value,
  schemaObject,
  user,
  LabelSession,
  LabPrefix
) => {
  let VIPSOrderDetailsItems = [];
  let iterateCount = 1;

  var pageIdOfSchemObject = schemaObject[0][0].pageId;
  let loopCount = 1;
  var QtyFieldName = value.QuantityFieldName;
  const filterUsrer = filterObjectByKey(user[0], value.TableName);
  const dynamicKeyName = Object.keys(filterUsrer)[0];

  const filteredArray = filterUsrer[dynamicKeyName].filter(
    (item) => item["ORDER Nº"] === value.PO
  );
  const filteredObject = { [dynamicKeyName]: filteredArray };

  // Resolve quantity field from schema subitems (QTY or catalogueSchemaType == 16)
  const qtyFieldFromSchema =
    schemaObject[0]
      ?.flatMap((s) => Array.isArray(s?.schemaPageSubItems) ? s.schemaPageSubItems : [])
      ?.find((x) => x?.prefix === "QTY" || x?.catalogueSchemaType === 16)
      ?.fieldName || (Array.isArray(value.QuantityFieldName) ? value.QuantityFieldName[0] : value.QuantityFieldName);

  // Use resolved qty field to determine loopCount (so CATQTY cases are included)
  if (value.TableName && qtyFieldFromSchema) {
    loopCount = filteredObject[value.TableName]?.filter(
      (x) => (x[qtyFieldFromSchema] ?? "").toString().length > 0
    )?.length || 0;
  } else if (value.TableName && QtyFieldName) {
    // Fallback to provided QuantityFieldName if schema didn't provide any
    const qfn = Array.isArray(QtyFieldName) ? QtyFieldName[0] : QtyFieldName;
    loopCount = filteredObject[value.TableName]?.filter(
      (x) => (x[qfn] ?? "").toString().length > 0
    )?.length || 0;
  }

  const hasLabel = Boolean(findLabelSchemaField(schemaObject[0], LabPrefix));
  for (let i = 0; i < loopCount; i++) {
    const lineNo = i + 1;
    let VIPSVarOrderDetailItem = [];

    // Compute row quantity to decide whether to skip
    let rowQty = value["Quantity"];
    if (value.TableName && qtyFieldFromSchema) {
      const row = filteredObject[value.TableName]?.[i];
      rowQty = row ? row[qtyFieldFromSchema] : rowQty;
    }
    const qtyNum = Number(rowQty);
    if (!Number.isFinite(qtyNum) || qtyNum <= 0) {
      continue; // skip zero or invalid qty rows
    }

    CreateVIPSVarOrderDetailItem(
      filteredObject,
      lineNo,
      i,
      schemaObject[0],
      VIPSVarOrderDetailItem,
      lineNo,
      pageIdOfSchemObject
    );

    if (!hasLabel) {
      const labelEntries = getLabelSessionEntries(LabelSession);
      const labelEntry = labelEntries[i] ?? labelEntries[0];
      const labelSchemaField = findLabelSchemaField(schemaObject[0], LabPrefix);
      const globalLabelSchemaField = findLabelSchemaFieldAcrossPages(
        schemaObject,
        LabPrefix
      );

      const schema = {
        tagName:
          labelEntry?.tagName ??
          labelSchemaField?.tagName ??
          globalLabelSchemaField?.tagName ??
          (value.LabelFieldName || `LABEL${i + 1}`),
        fieldName:
          labelEntry?.fieldName ??
          labelSchemaField?.fieldName ??
          globalLabelSchemaField?.fieldName ??
          (value.LabelFieldName || `LABEL${i + 1}`),
        prefix:
          labelEntry?.prefix ??
          labelSchemaField?.prefix ??
          globalLabelSchemaField?.prefix ??
          "LAB",
        pageId: pageIdOfSchemObject,
      };
      CreateVIPSVarOrderDetailItemObject(
        schema,
        value["ProductDesc"],
        `_1`,
        VIPSVarOrderDetailItem,
        schema.fieldName
      );
    }
    const quantity = qtyNum;

    const VIPSOrderDetailsItem = {
      line_no: iterateCount.toString().padStart(4, "0"),
      //original_sku_id: iterateCount.toString().padStart(4, "0"),
      block_no: value["LineNo"],
      product_id: value["ProductDesc"],
      quantity: quantity.toString(),
      erp_product_id: "",
      itemStatus: "Y",
      action: "",
      VIPSVarOrderDetailItem,
    };
    VIPSOrderDetailsItems.push(VIPSOrderDetailsItem);
    iterateCount++;
  }

  return VIPSOrderDetailsItems;
};

export function filterObjectByKey(object, key) {
  if (object.hasOwnProperty(key)) {
    return { [key]: object[key] };
  } else {
    return {};
  }
}
